import { render, staticRenderFns } from "./CaptchaWidget.vue?vue&type=template&id=695dbaae&"
import script from "./CaptchaWidget.vue?vue&type=script&lang=js&"
export * from "./CaptchaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports